module.exports = __webpack_public_path__ + "img/dyzj.6d92fd8a.png";